import { getUser } from "$lib/userstorage/usersotrage"
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
import { saveOffline, updateOffline, deleteOffline } from "$lib/outbox/saveOffline"
import { queryClient, cacheRestored } from "$lib/query/queryClient"
import { queryKeys } from "$lib/query/keys"
import { loadStorageEstablecimiento } from "$lib/java/establecimientos/establecimientostorage"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD=="si";
let RUTA_JAVA =bd_local? ruta_local_java:ruta_java;
const RUTA_TIPO_TRATAMIENTOS = "treatment-types"
const RUTA_TREATMENT_EVENTS = "treatment-events"

function processTipo(type) {

    let data_tipo = {
        id: type.treatmentTypeId,
        nombre: type.name,
        generico: type.isGeneric,
        active: type.isActive,
        cab: type.establishmentId
    }
    return data_tipo
}
export function processTipos(data, cabid = null) {
    let data_tipos = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        if (fila.isActive) {
            if (cabid) {
                if (fila.isGeneric || fila.establishmentId == cabid) {
                    data_tipos.push(processTipo(fila))
                }
            }
            else {
                data_tipos.push(processTipo(fila))
            }

        }

    }
    return data_tipos
}
export async function getGenericTipos() {
    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_TIPO_TRATAMIENTOS}/all?generic=true`
    let url = new URL(ruta)

    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await handleAuthenticatedRequest(url.toString(), options)

    let data_all = await jsonOrThrow(res_all, "tratamientos.getGenericTipos")



    let procesada = processTipos(data_all,1)

    return procesada
}
export async function getAllTipos(cabid = null) {
    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_TIPO_TRATAMIENTOS}/establishment/${cabid}`
    let url = new URL(ruta)
    
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await handleAuthenticatedRequest(url.toString(), options)

    let data_all = await jsonOrThrow(res_all, "tratamientos.getAllTipos")



    let procesada = processTipos(data_all,cabid)

    return procesada
}
function postDataTipo(data, establishmentId) {
    let data_tipo = {
        name: data.nombre,
        isGeneric: false,
        isActive: true,
        establishmentId: data.cab
    }
    return data_tipo
}
export async function saveTrata(data) {
    let ruta = `${RUTA_JAVA}${RUTA_TRATAMIENTOS}`
    let data_trata = postDataTrata(data)
    let user = getUser();
    let token = user.token;

    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data_trata), // data can be `string` or {object}!
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    if (!res_save.ok) throw new Error("Error al guardar tratamiento")
    let data_save = await res_save.json()
    let procesada = processTratamiento(data_save)

    return procesada
}
/** El establecimiento de la operación: el que trae el caller, o el activo. */
function tipoEstId(cabid) {
    return cabid ?? loadStorageEstablecimiento()?.id ?? null
}

// Alta de tipo de tratamiento OFFLINE-first (outbox + optimistic UI). Antes era
// un fetch directo, así que sin señal moría en red y la pantalla mostraba "no se
// pudo guardar". El backend lo crea vía TreatmentTypeDto {name, isGeneric,
// isActive, establishmentId} y deduplica por clientUuid (V28).
//
// El clientUuid se genera acá (y no dentro de saveOffline) para que el id
// optimista sea `pending-<clientUuid>`: así, si el usuario usa el tipo recién
// creado en un tratamiento sin haber sincronizado, el drainer puede resolver esa
// FK (treatmentTypeIds) contra el id real cuando el tipo se confirme.
//
// Devuelve la fila en la shape de processTipo, para que las pantallas la puedan
// insertar en su lista local igual que antes.
export async function saveTipo(data) {
    const estId = tipoEstId(data?.cab)
    const clientUuid = crypto.randomUUID()
    const optimisticRow = {
        id: `pending-${clientUuid}`,
        nombre: data.nombre,
        generico: false,
        active: true,
        cab: estId,
    }
    await saveOffline({
        entity: "treatmentType",
        clientUuid,
        // `cab: estId` y no `data.cab`: sin establishmentId el backend crearía el
        // tipo como GENÉRICO (establishment NULL, visible para todos los tenants).
        payload: postDataTipo({ ...data, cab: estId }),
        queryKey: queryKeys.treatmentTypes(estId),
        optimisticRow,
    })
    return { ...optimisticRow, _pendingSync: true, _clientUuid: clientUuid }
}
export async function editTratamiento(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_TRATAMIENTOS}/${id}`

    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "PUT",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    if (!res_post.ok) throw new Error("Error al editar tratamiento")
    let data_post = await res_post.json()
    return data_post
}
// Edición de tipo de tratamiento OFFLINE-first. `data` mantiene la shape que ya
// mandaban las pantallas ({name, establishmentId}) para no tocar los call sites.
// Si el tipo se creó sin conexión y su CREATE sigue encolado, updateOffline
// corrige ese CREATE en vez de mandar un UPDATE contra un id que el server no
// conoce (ver colapsarSobreCreate en saveOffline.js).
export async function editTipo(id, data) {
    const estId = tipoEstId(data?.establishmentId)
    await updateOffline({
        entity: "treatmentType",
        resourceId: id,
        payload: { name: data?.name, establishmentId: estId },
        queryKey: queryKeys.treatmentTypes(estId),
        optimisticRow: { nombre: data?.name },
    })
    return {}
}
function processTreatmentEvent(event) {
    return {
        id: event.treatmentEventId,
        fecha: event.treatmentDate,
        observacion: event.notes ?? "",
        animales: (event.animals ?? []).map(a => ({ id: a.animalId, caravana: a.tagNumber })),
        tipos: (event.types ?? []).map(t => ({ id: t.treatmentTypeId, nombre: t.name })),
    };
}

// Version de array (misma transformacion que aplica getAllEvents), exportada para
// sembrar el cache desde el snapshot offline con la shape identica a la online.
export function processTreatmentEvents(data) {
    return (data ?? []).map(processTreatmentEvent);
}

function isRealError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number")
}
export async function getAllEvents(cabid = null) {
    let user = getUser();
    let token = user.token;
    let ruta = `${RUTA_JAVA}${RUTA_TREATMENT_EVENTS}/all`
    let url = new URL(ruta)
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res = await handleAuthenticatedRequest(url.toString(), options)
        let data = await jsonOrThrow(res, "tratamientos.getAllEvents")
        return data.map(processTreatmentEvent)
    } catch (err) {
        if (isRealError(err)) throw err
        await cacheRestored
        const cached = cabid ? queryClient.getQueryData(queryKeys.treatments(cabid)) : null
        if (Array.isArray(cached)) return cached
        throw err
    }
}

export async function saveTreatmentEvent(data) {
    let user = getUser();
    let token = user.token;
    let ruta = `${RUTA_JAVA}${RUTA_TREATMENT_EVENTS}`
    let body = {
        treatmentDate: data.fecha,
        notes: data.observacion,
        animalIds: data.animalIds,
        treatmentTypeIds: data.tratamientoIds,
    }
    let res = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    let saved = await res.json()
    return processTreatmentEvent(saved)
}

export async function updateTreatmentEvent(id, data) {
    let user = getUser();
    let token = user.token;
    let ruta = `${RUTA_JAVA}${RUTA_TREATMENT_EVENTS}/${id}`
    let body = {
        treatmentDate: data.fecha,
        notes: data.observacion,
        animalIds: data.animalIds,
        treatmentTypeIds: data.tratamientoIds,
    }
    let res = await fetch(ruta, {
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    let saved = await res.json()
    return processTreatmentEvent(saved)
}

export async function eliminarEvento(id) {
    let user = getUser();
    let token = user.token;
    let ruta = `${RUTA_JAVA}${RUTA_TREATMENT_EVENTS}/delete/${id}`
    await fetch(ruta, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    return {}
}

// Borrado de tipo de tratamiento OFFLINE-first: saca la fila del cache y encola
// el DELETE (drena al reconectar). El id va CRUDO: si el tipo se creó offline es
// `pending-<uuid>` y deleteOffline descarta el CREATE encolado en vez de mandar
// un DELETE contra un id inexistente.
export async function deleteTipo(id) {
    const estId = tipoEstId()
    await deleteOffline({
        entity: "treatmentType",
        resourceId: id,
        queryKey: queryKeys.treatmentTypes(estId),
    })
    return {}
}